const PO_SO_TRACKING_ALLOWED_EMAILS = new Set([
    'adam@bdcc.com.au',
    'jeremy@caeruscorp.com.au',
    'megan@bdcc.com.au',
    'trung@caeruscorp.com.au',
    'orders@bdcc.com.au'
]);

/** Hardcoded allowlist for PO & SO Tracking UI (menu + route). */
export function canAccessPoSoTracking(email: string | undefined | null): boolean {
    if (!email) {
        return false;
    }
    return PO_SO_TRACKING_ALLOWED_EMAILS.has(email.trim().toLowerCase());
}
